export enum SlotValue {
  NoSlot = 0,
  OneSlot = 1,
  TwoSlot = 2,
  ThreeSlot = 3,
  FourSlot = 4,
}
